import { ApiRequestConfig, apiService } from './api.service';

import {
	IGlobalNotification,
	IUpdateGlobalNotification,
} from '@/interfaces/entities/global-notification';
import { IGlobalNotificationResponse } from '@/interfaces/entities/global-notification';
import { IApiService } from '@/interfaces/services/IApiService';

class GlobalNotificationService {
	api: IApiService<ApiRequestConfig>;

	constructor(api: IApiService<ApiRequestConfig>) {
		this.api = api;
	}

	async newGlobalNotification(globalNotification: IGlobalNotification) {
		this.api.post(`/global-notification`, globalNotification);
	}

	async getAllGlobalNotifications(
		pageNumber: number,
		config?: ApiRequestConfig,
	) {
		return await this.api.get<{
			data: IGlobalNotificationResponse[];
			pageCount: number;
		}>(
			`/global-notification?page[number]=${pageNumber}&sort[createdAt]=DESC`,
			config,
		);
	}

	async editGlobalNotifications(
		id: number,
		notification: IUpdateGlobalNotification,
		config?: ApiRequestConfig,
	) {
		return await this.api.patch<IGlobalNotificationResponse>(
			`/global-notification/${id}`,
			notification,
			config,
		);
	}

	async deleteGlobalNotifications(id: number) {
		return await this.api.delete(`/global-notification/${id}`);
	}
}

export const globalNotificationService = new GlobalNotificationService(
	apiService,
);
